<template lang="">
	<ParentGraph
		:title="$t('comp.graphText')"
		:show="errorImage"
	>
		<div
			class="position-relative"
			:style="errorImage ? 'top: 20px' : ''"
			v-if="!$siteconf.hideImages?.application"
		>
			<img
				v-if="errorImage"
				alt="white background"
				src="/s/images/Calque_7.png"
				class="position-absolute mt-5"
			>
			<img
				:src="imageSrc"
				ref="Image"
				class="position-relative"
				alt="white background"
			>
		</div>
	</ParentGraph>
</template>
<script>
import { imageErrorHandling} from "@/../public/js/imageErrorHandling"
export default {
	mixins: [imageErrorHandling],

	data() {
		return {
			errorImage: false,
			imageSrc: "/c/images/skill",
			fallbackImageSrc: "/s/images/Competences.png"
		};
	},
	mounted() {
		// Check the image dimensions on mount
		this.preloadImage(this.imageSrc, this.fallbackImageSrc);
	}
	};
</script>
<style lang="scss" scoped>
.img{
	height: 50%;
}
</style>